import { render, staticRenderFns } from "./HumanCapitalTurnoverInput.vue?vue&type=template&id=49be941f&scoped=true&"
import script from "./HumanCapitalTurnoverInput.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalTurnoverInput.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalTurnoverInput.vue?vue&type=style&index=0&id=49be941f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49be941f",
  null
  
)

export default component.exports